import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MaterialCircularProgress } from 'src/components/material/CircularProgress';
import { PathRoutes } from 'src/const/Routes/PathRoutes';

export const Oth360AuthRedirectPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const token =
      new URLSearchParams(location.search).get('token')?.trim() ||
      new URLSearchParams(window.location.search).get('token')?.trim() ||
      '';
    const target = token
      ? `${PathRoutes.Oth360InviteRoute}?token=${encodeURIComponent(token)}`
      : PathRoutes.Oth360InviteRoute;

    navigate(target, { replace: true });
  }, [location.search, navigate]);

  return <MaterialCircularProgress />;
};
